import React from 'react';
import { DropzoneOptions, DropzoneState, useDropzone } from 'react-dropzone';
import { Icon } from '../Icon/Icon';
import { Text } from '../Text/Text';
import { Wrapper, WrapperProps } from '../Wrapper/Wrapper';
import { StyledDropzone } from './Dropzone.styles';
import { Button } from '../Button/Button';

interface DropZoneOverlayProps {
  isDragActive: boolean;
  open?(): void;
}

export interface DropzoneProps extends WrapperProps {
  options: DropzoneOptions;
  children?(dropzoneBag: DropzoneState): React.ReactNode;
}

export const DropZoneOverlay: React.FC<DropZoneOverlayProps> = ({ isDragActive, open }) => {
  return (
    <StyledDropzone isDragActive={isDragActive}>
      <Icon className="far fa-arrow-circle-up" color="primary.500" fontSize="h3" mb="16" />

      <Text fontSize="h5" fontWeight={600}>
        Drag and drop files here
      </Text>

      {!!open && (
        <>
          <Text variant="smallCaps" my="16">
            or
          </Text>

          <Button leftIcon="fas fa-plus" onClick={open}>
            Browse files
          </Button>
        </>
      )}
    </StyledDropzone>
  );
};

export const Dropzone: React.FC<DropzoneProps> = ({ options, children, ...rest }) => {
  const dropzoneBag = useDropzone({
    noClick: true,
    ...options,
  });

  return (
    <>
      <Wrapper {...dropzoneBag.getRootProps()} {...rest}>
        <input {...dropzoneBag.getInputProps()} aria-label="Drop Zone" />

        <DropZoneOverlay isDragActive={dropzoneBag.isDragActive} open={dropzoneBag.open} />
      </Wrapper>

      {children && children(dropzoneBag)}
    </>
  );
};
